import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/services/global.service';
import { Constant } from 'src/constant';

@Component({
  selector: 'app-rpupifailure',
  templateUrl: './rpupifailure.component.html',
  styleUrls: ['./rpupifailure.component.css']
})
export class RpupifailureComponent implements OnInit {

  errorMsg:any;
  isSuccess:boolean = false;

  constructor(private service: GlobalService,private spinner: NgxSpinnerService,) { }

  ngOnInit() {
    if(localStorage.getItem('razorpayError')){
      this.errorMsg = JSON.parse(localStorage.getItem('razorpayError')|| '{}');
      console.log(this.errorMsg);
      this.isSuccess = true;
      this.saveFailedRes();
    }
  }

   // console.log('code:-',this.errorMsg.error.code);
    // console.log('desc:-',this.errorMsg.error.description);
    // console.log('payment ID:',this.errorMsg.error.metadata.payment_id);
    // console.log('order ID:',this.errorMsg.error.metadata.order_id);
    
    saveFailedRes(){
      let url = Constant.saveMandateSignUPI;
      if(this.errorMsg){
        let reqObj = {
          "razorpay_PaymentId": this.errorMsg.error.metadata.payment_id,
          "razorpay_orderId": this.errorMsg.error.metadata.order_id,
          "razorpay_signiture":""
      }
          this.service.PostService(url, reqObj).subscribe(response => {
              // add loader here 
          })
      }
    }


  ngOnDestroy() {
    localStorage.clear();
  }
}
